<template>
  <div class="ShoppingMall">
    <navigator title="园区商城"></navigator>

    <van-tabs @click="makeSecondList">
      <van-tab v-for="(item,index) in shoppingList" :key="index" :title="item.name"></van-tab>
    </van-tabs>

    <div class="searchBar">
      <van-search placeholder="请输入商品名称" v-model="condition.searchVal" class="searchClass" @keyup='titleFilter'/>
      <span class="screening"  @click="show">筛选<i class= "iconfont icon-shaixuan"></i></span>
    </div>

    <van-popup v-model="showPopup" class="selectPopup">
      <ul class="secBar">
        <li @click="typeFilter(itemAllId, 0)" :class="{'active' : action === -1 }">全部</li>
        <li v-for="(item, index) in secondList" :key="index" @click="typeFilter(item.id, 1)" :class="{'active' : action === item.id }">{{item.name}} </li>
      </ul>
    </van-popup>
    <div class="content">
      <van-list v-model="loading" :finished="finished" @load="loadMore">
        <div class="proItem " v-for="(item, index) in itemList" :key="index" @click="productsDetalis(item.categoryId, item.id)">
          <img :src="item.thumb[0].img" class="itemPic">
          <div class="itemText">
            <p class="itemTitle textOver">{{item.productName}}</p>
            <p class="itemCmp textOver">{{ item.createCorpName}}</p>
            <p class="itemPrice">￥ {{item.price / 100| PriceFilter}}</p>
          </div>
        </div>
      </van-list>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return{
      selected: '',
      shoppingList: [], // 大标题菜单
      secondList:[], // 二级菜单
      // 产品列表
      itemList: [],
      showPopup: false,
      pageIndex: 1,
      total: 0,
      condition: {
        searchVal: '',
        categoryId: '', // 分类ID
      },
      loading: false,
      finished: false,
      action: -1,
      itemAllId: 0, // 二级菜单的全部的id
    };
  },
  methods: {
    getTree() {
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/category/tree`, {
        parkId: this.currentParkId,
      }).then((res) => {
        if(res.data.resCode === '10000') {
          this.shoppingList = res.data.resData;
          this.shoppingList.splice(0, 1);
          this.condition.categoryId = this.shoppingList[0].id;
          this.makeSecondList(0);
        }
      });
    },
    makeSecondList(index) {
      const Obj = this.shoppingList[index];
      this.secondList = this.shoppingList[index].children ? this.shoppingList[index].children : [];
      this.condition.categoryId = this.shoppingList[index].id;
      this.itemAllId = this.shoppingList[index].id;
      this.pageIndex = 1;
      this.itemList =[];
      this.getList();
    },
    show() {
      this.showPopup = true;
    },
     // 按类型筛选
    typeFilter(id, index) {
      if(index === 0) {
        this.action = -1;
      }else{
        this.action = id;
      }
      this.condition.categoryId = id;
      this.condition.searchVal = '';
      this.showPopup = false;

      this.itemList =[];
      this.getList();
    },

    // 按关键字搜索
    titleFilter() {
      this.condition.categoryId = '';
      this.itemList =[];
      this.getList();
    },
    getList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/products/list`, {
        productName: this.condition.searchVal,
        pageRows: 10,
        currPage: this.pageIndex,
        categoryId: this.condition.categoryId,
      }).then((res) => {
        if(res.data.resCode === '10000') {
          // this.itemList = res.data.resData.pageList ? res.data.resData.pageList : [];
          this.total = res.data.resData.pageInfo ? res.data.resData.pageInfo.total : 0;
          const tempArr = res.data.resData.pageList ? res.data.resData.pageList : [];
          this.itemList = this.itemList.concat(tempArr);
          this.finished = this.itemList.length >= this.total ? true : false;
        }else{
          this.$toast(res.data.resDesc);
        }
        this.loading = false;
      });
    },
    productsDetalis(categoryId, id) {
      this.$router.push({ path: `/shoppingDetelis`, query:{categoryId: categoryId, id: id} });
    },
    loadMore() {
      if (this.itemList.length >= this.total) {
        return;
      }
      this.loading = true;
      this.pageIndex++;
      this.getList();
    },
  },
  created() {
    this.getTree();
    this.itemList = [];
  },
  computed: {
    ...mapGetters(['currentParkId', 'token']),
  },
}
</script>
<style lang="scss" scoped>
@import '~@scss';

.searchBar{
  padding: .32rem;
  .screening{
    margin-left: .4rem;
  }
}
.secBar{
  padding: .48rem .32rem;
  li{
    width: 2.133333rem;
    height: .64rem;
    border: 1px solid rgb(200, 200, 200);
    border-radius: .053333rem;
    float: left;
    font-size: .32rem;
    margin-right: .266667rem;
    margin-bottom: .266667rem;
    box-sizing: border-box;
    color: rgb(51, 51, 51);
    font-weight: 600;
    line-height: .64rem;
    overflow: hidden;
    &:nth-of-type(4n){
      margin-right: 0;
    }
    &.active{
      background: $color-main;
      color: #fff;
      border: none;
    }
  }
}
.content{
  padding: .333333rem;
  .proItem{
    width: 9.36rem;
    height: 2.666667rem;
    background-color: #fff;
    border-radius: .093333rem;
    margin-bottom: .32rem;
    display: flex;
    .itemPic{
      width: 2.666667rem;
      height: 2.666667rem;
      border-radius: .093333rem 0 0 .093333rem;
      display: inline-block;
      vertical-align: middle;
    }
    .itemText{
      display: inline-block;
      vertical-align: middle;
      flex: 1;
      padding: .32rem .253333rem;
      .itemTitle{
        color: rgb(51, 51, 51);
        font-size: .453333rem;
        font-weight: bold;
        width: 5.866667rem;
      }
      .itemCmp{
        font-size: .32rem;
        color: rgb(102, 102, 102);
        margin-top: .24rem;
        width: 5.866667rem;
      }
      .itemPrice{
        color: rgb(218, 37, 44);
        font-size: .4rem;
        font-weight: bold;
        margin-top: .32rem;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/shoppingMall/ShoppingMall.vue